var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{class:{ required: _vm.isRequired },attrs:{"label":_vm.label,"type":_vm.inputType,"message":_vm.errorMessage}},[_c('Editor',{attrs:{"api-key":'zpinnjapelzska9eq199pb02d8vnnsdj6pqwhnwoc2evx4cr',"init":{
      plugins: '',
      toolbar: '',
      menubar: '',
    }},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }